<terra-dialog-header>
  <h1>New Business Account</h1>
</terra-dialog-header>
<mat-dialog-content class="flex flex-column gap-5 new-business-account-dialog-content">
  <div class="supportive-text">
    Streamline your financial operations by opening a bank account and benefit from high APY% interest rates, along with FDIC insurance coverage up to $3 million<mat-icon class="cursor-pointer h-1rem w-1rem text-base ml-1" (click)="FDICInfo()">info</mat-icon>
  </div>
    <form class="flex flex-column gap-4 pb-4 terra-error-style" id="dialogFormEditBank" [formGroup]="pageForm"
    (keydown.enter)="$event.preventDefault()">
<div class="flex flex-column gap-1" 
  [style.opacity]="isHoldingIdInitiated() ? 0 : 1"
  [style.height.px]="isHoldingIdInitiated() ? 0 : null"
  [style.overflow]="isHoldingIdInitiated() ? 'hidden' : null"  
  >
  <label class="text-base line-height-3 flex gap-1 align-items-center">Entity type
    <mat-icon class="text-base h-auto" fontSet="material-icons-outlined" pTooltip="Choose whether this account belongs to a specific asset/fund or it is a GP Level account."
      tooltipPosition="top"
      tooltipStyleClass="text-center">help_outline</mat-icon>
  </label>
  <terra-radio-buttons [control]="pageForm.get('entityType')"
          [details]="entityTypesButtons"></terra-radio-buttons>
</div>
<div class="full-width flex flex-column gap-1">
  <label class="text-base line-height-3">{{selectedEntityType.selectingEntityPlaceholderlabel}}</label>
  <p-dropdown class="entity-dropdown-container" #businessTypeSelect [options]="selectedEntityType.selectingEntitySource | async"
  optionValue="id" optionLabel="id"
  [formControl]="pageForm.get(selectedEntityType.selectingEntityFormControlName)"
  [placeholder]="getSelectEntityPlaceholder()"
  [disabled]="pageForm.get(selectedEntityType.selectingEntityFormControlName)?.disabled"
  [style.cursor]="pageForm.get(selectedEntityType.selectingEntityFormControlName)?.disabled ? 'default' : null"
  styleClass="entity-dropdown">
  <ng-template let-selected pTemplate="selectedItem">
    <span>{{ selectedEntityType.itemLabelBuilder(selected) }}</span>
</ng-template>
  <ng-template let-entity pTemplate="item">
    <div class="flex justify-content-between">
        <span class="flex flex-wrap align-content-center">{{ selectedEntityType.itemLabelBuilder(entity) }}</span>
        <button *ngIf="selectedEntityType.value === EntityType.GpLevel" mat-icon-button>
          <mat-icon class="edit-icon" fontSet="material-icons-outlined" (click)="createEditCompany(entity); $event.stopImmediatePropagation(); $event.preventDefault()">edit</mat-icon>
        </button>
    </div>
</ng-template>
<ng-template pTemplate="footer">
  <div class="flex justify-content-center p-2 border-top-1 border-x-none border-bottom-none border-solid surface-border" *ngIf="selectedEntityType.shouldHaveAddFooter">
    <terra-buttons
        class="button-no-border"
        type="secondary"
        label="New Business Entity"
        icon="add"
        [outlinedIcon]="true"
        (click)="createEditCompany(null)"
      ></terra-buttons>
  </div>
</ng-template>
<ng-template pTemplate="empty">
  <div class="flex flex-column justify-content-center align-items-center gap-2">
    <mat-icon class="h-2rem w-2rem" [svgIcon]="selectedEntityType.value === EntityType.GpLevel ? 'business_entity' : null">
      {{selectedEntityType.value === EntityType.Holding ? 'domain' : null}}
    </mat-icon>
    <span class="text-sm">{{selectedEntityType.emptyStateText}}</span>
  </div>
</ng-template>
</p-dropdown>
<mat-error *ngIf="pageForm.get(selectedEntityType.selectingEntityFormControlName).hasError('required') && pageForm.get(selectedEntityType.selectingEntityFormControlName).touched"> Required</mat-error>
</div>
<div class="full-width flex flex-column gap-1" *ngIf="selectedEntityType.haveAccountType">
  <label class="text-base line-height-3">Account type</label>
  <p-dropdown
    [options]="accountTypes"
    [formControl]="pageForm.get('accountType')">
    <ng-template let-selected pTemplate="selectedItem">
      <div class="flex flex-row gap-2">
        <mat-icon [svgIcon]="AccountType.getIcon(selected)"></mat-icon>
        <span class="flex flex-wrap align-content-center">{{ selected | enumString:AccountType }}</span>
      </div>
    </ng-template>
    <ng-template let-entity pTemplate="item">
      <div class="flex flex-row gap-2">
        <mat-icon [svgIcon]="AccountType.getIcon(entity)"></mat-icon>
        <span class="flex flex-wrap align-content-center">{{ entity | enumString:AccountType }}</span>
      </div>
    </ng-template>
  </p-dropdown>
</div>
<!-- Account nickname -->
<div class="flex flex-column gap-1">
  <label for="txtNickname" class="text-base line-height-3">Account nickname</label>
  <mat-form-field appearance="outline">
    <input matInput id="txtNickname" formControlName="nickname" autocomplete="account-name" class="lo_sensitive" placeholder="e.g. Downtown Lofts Operating Account"/>
    <mat-error *ngIf="pageForm.get('nickname').hasError('required')"> Required</mat-error>
  </mat-form-field>
</div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-content-end pt-4 pb-0 new-business-account-dialog-actions">
<button #cancelButton [disabled]="false" [mat-dialog-close]="undefined" type="button" mat-button color="primary"
class="cancel-button tall-button mr-2">
Cancel
</button>
<terra-buttons type="primary" label="Open Business Account" (click)="actionButtonClicked()"></terra-buttons>
</mat-dialog-actions>

<terra-unit-bank-sticky-footer
[bankingProviderString]="bankingProviderString$ | async"
[accountProvider]="accountProvider$ | async"></terra-unit-bank-sticky-footer>
